import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../i18n';

import { Layout, Divider } from '../../element';

import { actions as ratesActs, selectors as fromRates } from '../../../entities/rates';

import { ProviderCard } from './provider-card';
import { DeliveryMethod } from './delivery-method';
import { ParcelType } from './parcel-type';
import { ProviderAddressForm } from '../../providers/provider-address-form';
import { CustomsDeclaration } from './customs-declaration';
import { RatesRules } from './rules';
import { DeclarationModal } from '../declaration-modal';
import { CourierModal } from '../courier-modal';
import { ZipModal } from '../zip-modal';
import { ExtensionsContainer } from '../extensions';

const ParcelCommon: React.FC = () => (
  <Layout.Row gutter={20}>
    <Layout.Col span={24} xs={24} sm={24} md={12} lg={12}>
      <ProviderCard className="mb-40" />
      <DeliveryMethod />
    </Layout.Col>

    <Layout.Col span={24} xs={24} sm={24} md={12} lg={12}>
      <ParcelType />
    </Layout.Col>
  </Layout.Row>
);

const Declaration: React.FC = () => {
  const [t] = useTranslation('rates');

  return (
    <>
      <h2>{t('rates.declaration.title')}</h2>
      <CustomsDeclaration />
    </>
  );
};

const Rules: React.FC = () => {
  const dispatch = useDispatch();

  return (
    <>
      <RatesRules onChange={(accepted: boolean) => dispatch(ratesActs.setRulesAccept({ accepted }))} />
    </>
  );
};

export const RatesForm: React.FC = () => {
  const declarationPrice = useSelector(fromRates.getDeclarationFullPrice);

  return (
    <>
      <ParcelCommon />
      <Divider type="horizontal" />
      <ProviderAddressForm />
      <Divider type="horizontal" />
      <Declaration />
      <CourierModal />
      <ZipModal />
      <DeclarationModal />
      {Boolean(declarationPrice) && (
        <>
          <Divider type="horizontal" />
          <ExtensionsContainer />
        </>
      )}
      <Divider type="horizontal" />
      <Rules />
    </>
  );
};
